var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4800_4153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1911 0H28.8231L20.8158 10.2194H11.1838L19.1911 0Z",
    fill: "#F9DD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1912 0H23.2618L15.2545 10.2194H11.1838L19.1912 0Z",
    fill: "#6FC0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3047 0H25.7101L17.7027 10.2194H14.2974L22.3047 0Z",
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32C21.5098 32 25.9763 27.5335 25.9763 22.0238C25.9763 16.5141 21.5098 12.0476 16.0001 12.0476C10.4904 12.0476 6.02393 16.5141 6.02393 22.0238C6.02393 27.5335 10.4904 32 16.0001 32Z",
    fill: "#FBC247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1841 13.2855V10.2194H20.8161V13.2855L22.4488 14.412V9.40298C22.4488 8.95236 22.0837 8.58667 21.6325 8.58667H10.3678C9.9172 8.58667 9.55151 8.95236 9.55151 9.40298V14.4126L11.1841 13.2855Z",
    fill: "#DD8D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 29.4923C20.1246 29.4923 23.4684 26.1486 23.4684 22.0239C23.4684 17.8992 20.1246 14.5554 15.9999 14.5554C11.8752 14.5554 8.53149 17.8992 8.53149 22.0239C8.53149 26.1486 11.8752 29.4923 15.9999 29.4923Z",
    fill: "#DD8D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8088 0H3.17676L11.1841 10.2194H20.8161L12.8088 0Z",
    fill: "#6FC0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8088 0H8.73804L16.7454 10.2194H20.8161L12.8088 0Z",
    fill: "#F9DD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69541 0H6.29004L14.2974 10.2194H17.7027L9.69541 0Z",
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7186 26.8889C13.5296 26.8889 13.3811 26.8339 13.2731 26.7241C13.1651 26.6142 13.1111 26.4677 13.1111 26.2846C13.1111 26.0924 13.1651 25.9459 13.2731 25.8452C13.3811 25.7445 13.5296 25.6941 13.7186 25.6941H15.3655V18.3882H16.0675L14.0965 19.6654C13.9526 19.7478 13.8176 19.7798 13.6916 19.7615C13.5746 19.7432 13.4711 19.6929 13.3811 19.6105C13.3001 19.5281 13.2416 19.4274 13.2056 19.3083C13.1786 19.1893 13.1876 19.0657 13.2326 18.9376C13.2866 18.8094 13.3811 18.7041 13.5161 18.6217L15.379 17.4269C15.532 17.3354 15.676 17.2621 15.811 17.2072C15.955 17.1431 16.09 17.1111 16.216 17.1111C16.369 17.1111 16.495 17.1569 16.5939 17.2484C16.7019 17.3308 16.7559 17.4727 16.7559 17.6741V25.6941H18.2679C18.4659 25.6941 18.6189 25.7445 18.7269 25.8452C18.8349 25.9459 18.8889 26.0924 18.8889 26.2846C18.8889 26.4769 18.8349 26.6279 18.7269 26.7378C18.6189 26.8385 18.4659 26.8889 18.2679 26.8889H13.7186Z",
    fill: "#F8D996"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4800_4153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop1);
export default __webpack_public_path__ + "static/media/top1.cfa5d1443a5a6f200f5b7719235b62f1.svg";
export { ForwardRef as ReactComponent };